<template>
<div>
    <a-modal
      :title="title"
      :visible="visible"
     :confirm-loading="confirmLoading"
     width="480px"
      @cancel="handleCancel"
    >
     <a-input-group compact style="margin-bottom:10px;">
      <a-select default-value="zname" @change="onSearchChange">
        <a-select-option value="zname">
          {{name_title}}
        </a-select-option>
        <a-select-option value="zcode">
          {{code_title}}
        </a-select-option>
        <a-select-option value="zorgname">
          {{org_name}}
        </a-select-option>
      </a-select>
      <a-input-search style="width: 50%" default-value=""  @search="onSearch" />
    </a-input-group>

     <a-table
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:rowsType}"
      :columns="columns"
      :data-source="list"
      :rowKey="c_row_key"
      :pagination="false"
    />
    <br />
    <a-pagination v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
    
     <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
          确定
        </a-button>
      </template>
    </a-modal>
  </div>
  
</template>
<script>
const columns = [
    {
        title: '用户编码',
        dataIndex: 'organizationleader',
        align: 'center',
        width:80,
    }, {
        title: '用户姓名',
        dataIndex: 'fullname',
        align: 'center',
        width:80
    }
    , {
        title: '组织名称',
        dataIndex: 'organizationname',
        align: 'center',
        width:80
    }
];

const columns2 = [
    {
        title: '用户编码',
        dataIndex: 'usercode',
        align: 'center',
        width:80,
    }, {
        title: '用户姓名',
        dataIndex: 'fullname',
        align: 'center',
        width:80
    }
    , {
        title: '组织名称',
        dataIndex: 'organizationname',
        align: 'center',
        width:80
    }
];

export default {
    data() {
        return {
            confirmLoading: false,
            columns:columns,
            selectedRowKeys: [], // Check here to configure the default column
            loading: false,
            rowsType:'radio',
            title:'',
            visible:false,
            list:[],
            searchKey:'zname',
            searchVal:'',
            usercode:'',
            name_title:'用户姓名',
            code_title:'用户编码',
            org_name:'组织名称',
            pagination:{
                total:0,
                pageSize:10,
                current:1,
            },
            selectType:undefined,
            c_row_key:'',
            all_list:[],
            already_paged:[],
        };
    },
    computed: {
        hasSelected() {
            return this.selectedRowKeys.length > 0;
        },
    },
    props:{
 
    },
    methods: {
        handlePageChange(params_page){
            this.onModalInit(params_page,this.selectType)
        },
        onModalInit(current_page,selectType){
            current_page = current_page ? current_page : 1;
            this.selectType = selectType
            if(selectType == '1'){
                //用户选择
                this.rowsType = 'checkbox'
                this.c_row_key = 'usercode'
                this.columns = columns2
            }
            else{
                //上级选择
                this.rowsType = 'radio'
                this.c_row_key = 'organizationleader'
                this.columns = columns
            }
            let that = this;
            let c_params = {
                pageSize:that.pagination.pageSize,
                page:current_page,
                urlparams:false
            }
            if(that.searchKey == 'zname'){
                c_params.fullname = that.searchVal
            }
            else if(that.searchKey == 'zcode'){
                c_params.usercode = that.searchVal
            }
            else{
                c_params.organizationname = that.searchVal
            }
            console.log(c_params);
            let c_type_name = 'orgcenter/queryUser';
            if(this.selectType == 1){
                c_type_name = 'rolecenter/selectAuthUser'
                c_params.type = 0
                const { query} = this.$route;
                c_params.roleid = query.id;
            }
            that.$store.dispatch({
                type: c_type_name,
                params:c_params,
                showMsg: false
            }).then((res)=>{
                let result = res.data.data;
                that.list = result.list;
                if(that.already_paged.indexOf(c_params.page) == -1){
                    that.already_paged.push(c_params.page);
                    that.all_list = that.all_list.concat(result.list)
                }
                that.pagination.total = result.totalRecords;
                that.pagination.pageSize = result.pageSize;
                that.pagination.current = result.page;
                that.title = '选择组织负责人';
            })
            that.visible = true;
        },


        onSearchChange(value){
            this.searchKey = value;
        },
        onSearch(value){
            this.searchVal = value;
            this.onModalInit(1,this.selectType);
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        handleOk(){
            let current_keys = this.selectedRowKeys;
            let result =[];
            if(this.selectType == 1){
                result = this.all_list.filter(function(n){
                    return current_keys.indexOf(n.usercode) != -1
                });
            }
            else{
                result = this.all_list.filter(function(n){
                    return current_keys.indexOf(n.organizationleader) != -1
                });
            }
            console.log(result)
            this.$emit('onModalHide',result);
            this.visible = false;
        },
        handleDeleteSelect(c_code){
            if(this.selectType == 1){
                this.all_list = this.all_list.filter(function(n){
                    return n.usercode != c_code
                });
                this.selectedRowKeys  = this.selectedRowKeys.filter(function(n){
                    return n != c_code
                });
                this.list= this.list.filter(function(n){
                    return n.usercode != c_code
                });
            }
            else{
                this.all_list = this.all_list.filter(function(n){
                    return n.organizationleader != c_code
                });
                this.selectedRowKeys  = this.selectedRowKeys.filter(function(n){
                    return n != c_code
                });
                this.list= this.list.filter(function(n){
                    return n.organizationleader != c_code
                }); 
            }
        },
        handleCancel(e) {
            e.preventDefault()
            this.$emit('onModalHide');
            this.visible = false;
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    mounted() {

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
